import ReactDOM from 'react-dom/client';
import './index.css';
import { Analytics } from "@vercel/analytics/react"
import App from './App';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <>
      <App />
      <Analytics />
    </>
);
